import { GetListLimit } from './Limits';

export type Company = {
  id: string;
  name: string;
};

export type CompanyDetail = {
  id: string;
  name: string;
  active?: boolean | null;
  creation_date?: Date | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  address_1?: string | null;
  address_2?: string | null;
  tax_id?: string | null;
  app_keys?: string[];
  sdi?: string | null;
  phone?: string | null;
  billing_key?: string | null;
  size?: string;
  usage?: string;
  deleted_at?: string | null | string;
  deleted_by?: string | string;
};

export type CreateCompanyPayload = {
  name: string;
  active: boolean | null;
  creation_date: Date | null;
  country: string | null;
  state: string | null;
  city: string | null;
  address_1: string | null;
  address_2: string | null;
  tax_id: string | null;
  sdi: string | null;
  phone: string | null;
  billing_key: string | null;
  size: string;
  usage: string;
};

export type GetCompaniesAdminParams = {
  max_items: GetListLimit;
  start: number;
  search: string | null | undefined;
};
export type GetCompaniesPayload = {
  max_items: 5 | 10 | 25 | 100 | 2000;
  start: number;
  search: string | null | undefined;
} & {
  show_deleted?: boolean;
};

export type GetCompaniesSort = 'dateAsc' | 'dateDesc' | 'scoreAsc' | 'scoreDesc';

export interface CreateAndUpdateCompanyResponse {
  requestId: string;
  status: string;
  endpointName: string;
  startedTimeStamp: number;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  data:
    | {
        id: string;
        name: string;
        billing_key: string | null;
        app_keys: [];
        active: true;
        creation_date: string;
        country: string;
        state: string;
        city: string;
        address_1: string;
        address_2: string;
        tax_id: string;
        sdi: string;
        phone: string;
        size: string;
        usage: string;
      }
    | {
        message: string;
        violations: string;
        id: string;
        name: string;
      };
  id: string;
  name: string;
  fulfilledTimeStamp: number;
  isUninitialized: boolean;
  originalArgs: {
    id?: string;
    name: string;
    country: string;
    city: string;
    state: string;
    address_1: string;
    address_2: string;
    tax_id: string;
    sdi: string;
    phone: string;
    active: boolean;
    size: string;
    usage: string;
    billing_key: string | null;
  };
}

export interface DeleteCompanyResponse {
  requestId: string;
  status: string;
  endpointName: string;
  startedTimeStamp: number;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  data: {
    id: string;
    name: string;
  };
  id: string;
  name: string;
  fulfilledTimeStamp: number;
  isUninitialized: boolean;
  originalArgs: {
    id: string;
  };
}
export interface DeleteCompanyPayload {
  id: string;
}
export interface GetCompaniesResponse {
  items: CompanyDetail[];
  total: number;
  filters: {
    max_items: 5 | 10 | 25 | 100 | 2000;
    start: number;
    search: string | null | undefined;
  };
  show_deleted?: boolean;
}

export const companiesDeletedFilterValues = ['Inactive', 'Active'] as const;
// convert array of Use Cases Urls into string literal union type
export type CompaniesDeletedFilterValuesType = (typeof companiesDeletedFilterValues)[number];
